import dialog from './dialog.vue';

export default dialog;
